const { location, queryParams } = require('@wix/site-location');
const { lightbox } = require('@wix/site-window');

const { setParamInSession } = require('../public/paramsHandler');

async function previewModalOnReady(_$w) {
  const BRANCH_ID_KEY = 'branchId';
  const SITE_REVISION_KEY = 'siteRevision';

  const { branchId } = await lightbox.getContext();

  _$w('#branchText').text = `Branch ID: ${branchId}`;

  _$w('#previewBtn').onClick(async () => {
    await setParamInSession(BRANCH_ID_KEY, branchId);
    await lightbox.close();
  });

  _$w('#productionBtn').onClick(async () => {
    queryParams.queryParams().remove([BRANCH_ID_KEY, SITE_REVISION_KEY]);
    const url = await location.url();

    location.to(url);
  });
}

module.exports = { previewModalOnReady };
